import axios from "axios";
import {getItem, setItem} from "../cache/cacheService";
import {runPreservingUserConsoleStorage} from "../../utils/userConsoleLogs";

import {
    ACCOUNT_WEB_LOGIN,
    ERROR_ACCOUNT_WEB_LOGIN, GET_ALL_SIMPLE_USERS, GET_CAMPAIGN_ACD_DICTIONARY,
    GET_CAMPAIGN_CONTACTS, GET_CAMPAIGN_CONTACTS_PAGINATION,
    GET_CONTACTS_BY_CAMPAIGN_DASHBOARD,
    SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING,
    GET_COMPANIES,
    GET_COMPANIES_ARCHIVED,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_TYPE,
    GET_COMPANIES_DIRECTORIES_PHONE_TYPE, GET_COMPANIES_DIRECTORIES_SCHEDULER_TYPE,
    GET_COMPANIES_DIRECTORIES_TRANKS_PHONE,
    GET_COMPANY,
    GET_NOTIFICATION,
    GET_NOTIFICATION_ERROR,
    GET_PAGINATION,
    GET_USERS, SET_LOADING, SHOW_CAMPAIGN_DETAIL_LOADING,
    SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR,

} from "../types/types";
import {GET_CAMPAIGNS_FOR_LEADS_LIST, GET_CAMPAIGN_LEADS_FILES_HISTORY, SET_CAMPAIGN_LEADS_FILES_HISTORY_LOADER, GET_CAMPAIGN_LEADS_FILES_PAGINATION} from "../types/types";
import {CompaniesData, StateCampaign, UserLoginData} from "types/types";
import {API_URL} from "redux/config";
import {setColorScheme} from "../actions/actionsTheme";
import {clearSessionEndedNotice} from "../../utils/sessionEndedNotice";
import {
    getCampaignDirectoriesCampaignTypeError, googleAuthLoginError,
    hideCompanyCreateMessage,
    hideCompanySaveMessage,
    hideError,
    hideErrorMessage,
    hideLoader,
    hideLoaderStrategyDict,
    setArchiveTableToggle,
    setCompanyStateSave,
    setContactsLoader, setErrorFields, setFirstTabLogin,
    showCompanyCreateMessage,
    showCompanyDeleteMessage,
    showCompanySaveMessage,
    showError,
    showErrorMessage,
    showGetCampaignDirectoriesPhoneTypeError,
    showLoader,
    showLoaderStrategyDict,
    showUpdatedError
} from "../actions/actions";
import {showRolesErrorMessage} from "../actions/actionsRoles";
import {showAccessDeniedNotifications, showErrorTokenNotifications} from "../actions/actionsNotifications";
import {logAction} from "../../utils/appEventLogs";
import {isFinishedLogin, readLoginAuthCodeRequired, readLoginAuthNotice, readLoginAuthenticatorQr, readLoginSuccessNotice, readTwoFactorChallenge, removeTwoFactorChallenge, storeTwoFactorChallenge} from "../../utils/twoFactorAuth";
import {setUserError} from "../actions/actionsUsersList";
import {SET_CHECK_PICK_UP_CALL, SET_CHECK_SESSION_FOR_SPY, SET_CHECK_USER_FOR_CALL, SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {triggerPickupCall} from "../actions/actionsWebRTC";
import {fetchTrunksPhonesCatalog} from "./sharedCatalogRequests";
import {CLEAR_TWO_FACTOR_CHALLENGE, SET_CAMPAIGN_AMD_SETTINGS, SET_TWO_FACTOR_CHALLENGE, SET_TWO_FACTOR_SETTINGS} from "../types/types";

function isServerFailureStatus(statusCode: unknown) {
    return typeof statusCode === 'number' && statusCode >= 500;
}

let dataSort = {
    isArchived: false,
    pageNumber: 1,
    pageSize: 10,
    sort: {
        orderBy: "CampaignId",
        isDesc: true
    }
}

export function getCampaignDirectoriesPhoneType(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(showGetCampaignDirectoriesPhoneTypeError(false))
        axios.get(`${API_URL}DialerDictionary/GetDictionary/true?parentId=100`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_COMPANIES_DIRECTORIES_PHONE_TYPE, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showGetCampaignDirectoriesPhoneTypeError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getCampaignDirectoriesCampaignType(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(getCampaignDirectoriesCampaignTypeError(false))
        axios.get(`${API_URL}DialerDictionary/GetDictionary/true?parentId=200`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_TYPE, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(getCampaignDirectoriesCampaignTypeError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(getCampaignDirectoriesCampaignTypeError(false))
            })
    }
}

export function getCampaignDirectoriesSchedulerType(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(getCampaignDirectoriesCampaignTypeError(false))
        axios.get(`${API_URL}DialerDictionary/GetDictionary/true?parentId=400`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_COMPANIES_DIRECTORIES_SCHEDULER_TYPE, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(getCampaignDirectoriesCampaignTypeError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(getCampaignDirectoriesCampaignTypeError(false))
            })
    }
}

export function getCampaignDirectoriesGetTranksPhones(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch({type: SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR, payload: false})
        return fetchTrunksPhonesCatalog(jwtToken)
            .then((data) => {
                dispatch({type: GET_COMPANIES_DIRECTORIES_TRANKS_PHONE, payload: data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    return dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR, payload: true})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getCampaignDirectoriesCampaignStrategy(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showLoaderStrategyDict())
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR, payload: false})
        axios.get(`${API_URL}DialerDictionary/GetDictionary/true?parentId=300`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY, payload: response.data.data})
                dispatch(hideLoaderStrategyDict())
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR, payload: true})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getCampaignId(id: number | any, jwtToken: any) {
    return (dispatch: (arg0: any) => void, getState: () => any) => {
        if (getState()?.CompaniesListReducer?.companyStateSave) {
            return;
        }
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch({type: SHOW_CAMPAIGN_DETAIL_LOADING, payload: true});
        axios.get(`${API_URL}Campaign/CampaignId/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (getState()?.CompaniesListReducer?.companyStateSave) {
                    return;
                }
                dispatch({type: GET_COMPANY, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_CAMPAIGN_DETAIL_LOADING, payload: false});
            })
    }
}

function getAllVisibleUsersUrl(isArchived: boolean = false) {
    return `${API_URL}Users/GetAllVisibleUsers?isArchived=${isArchived}`;
}

export function getUsers(jwtToken: any, isArchived: boolean = false) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(getAllVisibleUsersUrl(isArchived), {
            headers: {
                'Content-Type': 'application/json',
                // "x-access-userid": jwtToken?.userId
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_USERS, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getAllSimpleUsers(jwtToken: any, isArchived: boolean = false) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(getAllVisibleUsersUrl(isArchived), {
            headers: {
                'Content-Type': 'application/json',
                // "x-access-userid": jwtToken?.userId
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_ALL_SIMPLE_USERS, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function deleteCompanies(CampaignId: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(showCompanyDeleteMessage(false));
        axios.delete(`${API_URL}Campaign/${CampaignId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                    return;
                }
                let data = {
                    "isArchived": false,
                    "pageNumber": 1,
                    "pageSize": 10,
                    "sort": {
                        "orderBy": "CampaignId",
                        "isDesc": true
                    },
                    "filter": []
                }
                dispatch(getCompaniesWithPaginationFilterAndSorting(sort || data, jwtToken));
                dispatch(showCompanyDeleteMessage(true));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function createCompanies(data: CompaniesData, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideCompanyCreateMessage())
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.post(`${API_URL}Campaign/Create`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_COMPANY, payload: response.data.data})
                    dispatch(setCompanyStateSave(false))
                    dispatch(getCompaniesWithPaginationFilterAndSorting(dataSort, jwtToken));
                    dispatch(showCompanyCreateMessage())
                }
                if (response.data.statusCode === 400) {
                    let errorMessage = {"nameUniq": "Назва кампанії вже існує"};
                    dispatch(setErrorFields(errorMessage));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function updateCompanies(data: CompaniesData, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideCompanySaveMessage())
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.put(`${API_URL}Campaign/Update`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showUpdatedError());
                    return;
                }
                dispatch({type: GET_COMPANY, payload: response.data.data})
                dispatch(getCompaniesWithPaginationFilterAndSorting(dataSort, jwtToken));
                dispatch(showCompanySaveMessage())
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showUpdatedError())
                }
            })
            .finally(() => {
                dispatch(hideCompanySaveMessage())
                dispatch(showAccessDeniedNotifications(false));
            })

    }
}

function clearPendingTwoFactor(dispatch: (arg0: any) => void) {
    removeTwoFactorChallenge();
    dispatch({type: CLEAR_TWO_FACTOR_CHALLENGE});
}

export function holdTwoFactorChallenge(dispatch: (arg0: any) => void, body: any): boolean {
    const challenge = readTwoFactorChallenge(body);
    if (!challenge) {
        return false;
    }
    storeTwoFactorChallenge(challenge);
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('expirationTime');
    localStorage.removeItem('authToken');
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('callcenter:accountWebLogin');
    dispatch({type: SET_TWO_FACTOR_CHALLENGE, payload: challenge});
    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {error: null, loading: false}});
    dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}});
    return true;
}

export function finishPasswordLogin(dispatch: (arg0: any) => void, userData: any, password?: string, statusCode: number | string = 200) {
    if (!userData?.jwtToken?.jwtToken) {
        return false;
    }
    sessionStorage.setItem('firstTabLogin', 'true');
    if (password) {
        userData.pass = password;
    }
    dispatch({type: ACCOUNT_WEB_LOGIN, payload: userData});
    const user = {userName: userData?.userName, userId: userData?.userId};
    const expirationTime = Date.now() + userData.jwtToken?.expiresIn * 1000;
    localStorage.setItem('expirationTime', String(expirationTime));
    sessionStorage.setItem('expirationTime', String(expirationTime));
    localStorage.setItem('user', JSON.stringify(user));
    const {jwtToken, ...cleanUserData} = userData;
    localStorage.setItem('callcenter:user', JSON.stringify(cleanUserData));
    localStorage.setItem('callcenter:accountWebLogin', String(statusCode));
    sessionStorage.setItem('authToken', userData.jwtToken?.jwtToken);
    localStorage.setItem('authToken', userData.jwtToken?.jwtToken);
    sessionStorage.removeItem('isLoggedOut');
    clearSessionEndedNotice();

    if (userData?.theme === 'light' || userData?.theme === 'dark') {
        dispatch(setColorScheme(userData.theme));
    } else {
        dispatch(setColorScheme('dark'));
    }

    dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}});
    dispatch(setFirstTabLogin(true));
    return true;
}

type PendingPasswordLogin = {
    userData: any;
    password?: string;
    statusCode: number | string;
};

let pendingPasswordLogin: PendingPasswordLogin | null = null;

export function clearPendingPasswordLogin() {
    pendingPasswordLogin = null;
}

export function completePendingPasswordLogin(dispatch: (arg0: any) => void) {
    if (!pendingPasswordLogin) {
        return false;
    }
    const pending = pendingPasswordLogin;
    pendingPasswordLogin = null;
    return finishPasswordLogin(dispatch, pending.userData, pending.password, pending.statusCode);
}

const emptyLoginError = {"statusCode": null, "title": null, "message": null, "data": null};

export function accountWebLogin(data: UserLoginData) {
    return (dispatch: (arg0: any) => void) => {
        const confirmingCode = Boolean(data.code2FA);
        clearPendingPasswordLogin();
        dispatch({type: SET_LOADING, payload: true});
        if (!confirmingCode) {
            dispatch({type: CLEAR_TWO_FACTOR_CHALLENGE});
        }
        dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {error: null, loading: confirmingCode}});
        runPreservingUserConsoleStorage(() => {
            sessionStorage.clear();
            localStorage.clear();
        });
        dispatch(showRolesErrorMessage(false))
        axios.post(`${API_URL}AccountWeb/login`, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                dispatch({type: SET_LOADING, payload: false});
                if (holdTwoFactorChallenge(dispatch, response.data)) {
                    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {loading: false, enrollmentQr: null}});
                    return;
                }
                const enrollmentQr = readLoginAuthenticatorQr(response.data);
                if (enrollmentQr) {
                    dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: emptyLoginError});
                    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {enrollmentQr, awaitingAuthCode: false, error: null, loading: false, authNotice: null}});
                    return;
                }
                if (readLoginAuthCodeRequired(response.data)) {
                    dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: emptyLoginError});
                    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {awaitingAuthCode: true, enrollmentQr: null, error: null, loading: false, authNotice: readLoginAuthNotice(response.data)}});
                    return;
                }
                if (isFinishedLogin(response.data)) {
                    const loginSuccessNotice = readLoginSuccessNotice(response.data);
                    dispatch({type: CLEAR_TWO_FACTOR_CHALLENGE});
                    if (loginSuccessNotice) {
                        dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {loginSuccessNotice}});
                    }
                    finishPasswordLogin(dispatch, response.data.data, data.password, 200);
                    return;
                }
                logAction('login_failed', {
                    statusCode: response.data?.statusCode,
                    message: response.data?.message || response.data?.title
                });
                dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {loading: false, error: confirmingCode ? (response.data?.message || response.data?.title || 'Невірний код') : null}});
                dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: response.data})
                dispatch({type: SET_LOADING, payload: false});
            })
            .catch((error: any) => {
                if (holdTwoFactorChallenge(dispatch, error?.response?.data)) {
                    dispatch({type: SET_LOADING, payload: false});
                    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {loading: false, enrollmentQr: null}});
                    return;
                }
                logAction('login_failed', {message: error?.message || 'network'});
                dispatch({type: SET_LOADING, payload: false});
                dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {loading: false}});
                if (confirmingCode) {
                    const message = error?.response?.data?.message || error?.response?.data?.title || 'Не вдалося перевірити код';
                    dispatch({type: SET_TWO_FACTOR_SETTINGS, payload: {error: message, loading: false}});
                    dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {statusCode: error?.response?.status || null, title: null, message, data: null}});
                    return;
                }
                return dispatch(showError())
            })
    }
}

export function googleAccountWebLogin(id: any) {
    return (dispatch: (arg0: any) => void) => {
        let hash = window.location.hash;
        if (id && hash?.includes("auth_google?id")) {
            dispatch({type: SET_LOADING, payload: true});
            dispatch(showRolesErrorMessage(false))
            axios.get(`${API_URL}AccountWeb/GoogleLogin?id=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    cache: 'no-store',
                    'Cache-Control': 'no-cache'
                }
            })
                .then((response) => {
                    dispatch({type: SET_LOADING, payload: false});
                    if (holdTwoFactorChallenge(dispatch, response.data)) {
                        return;
                    }
                    if (response.data.statusCode === 200) {
                        clearPendingTwoFactor(dispatch);
                        dispatch({type: ACCOUNT_WEB_LOGIN, payload: response.data.data});
                        const user = {userName: response.data.data?.userName, userId: response.data.data?.userId};
                        let userData = response.data.data;
                        const expirationTime = Date.now() + response.data.data.jwtToken?.expiresIn * 1000;
                        localStorage.setItem('expirationTime', String(expirationTime));
                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('callcenter:user', JSON.stringify(userData));
                        localStorage.setItem('callcenter:accountWebLogin', '300');
                        dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}})
                        sessionStorage.setItem('authToken', response.data.data.jwtToken?.jwtToken);
                        sessionStorage.setItem('expirationTime', String(expirationTime));
                        sessionStorage.removeItem('isLoggedOut');
                        clearSessionEndedNotice();

                        if (response.data.data?.theme === 'light' || response.data.data?.theme === 'dark') {
                            dispatch(setColorScheme(response.data.data.theme));
                        } else {
                            dispatch(setColorScheme('dark'));
                        }

                        dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}});
                        dispatch(setFirstTabLogin(true));
                    } else {
                        logAction('google_login_failed', {
                            statusCode: response.data?.statusCode,
                            message: response.data?.message || response.data?.title
                        });
                        dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: response.data})
                        dispatch({type: SET_LOADING, payload: false});
                    }
                })
                .catch((e) => {
                    if (holdTwoFactorChallenge(dispatch, e?.response?.data)) {
                        dispatch({type: SET_LOADING, payload: false});
                        return;
                    }
                    logAction('google_login_failed', {message: e?.response?.data?.title || e?.message || 'network'});
                    dispatch({type: SET_LOADING, payload: false});
                    dispatch(googleAuthLoginError(e?.response?.data?.title || true));
                })
        }
    }
}

export function updateStateCampaign(data: StateCampaign, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideCompanySaveMessage());
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.post(`${API_URL}Campaign/StateCampaing`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else if (response.data.statusCode === 100) {
                    dispatch(showErrorMessage(response.data.message));
                } else {
                    dispatch({type: GET_COMPANY, payload: response.data.data});
                    dispatch(getCompaniesWithPaginationFilterAndSorting(dataSort, jwtToken));
                    dispatch(showCompanySaveMessage());
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(hideCompanySaveMessage());
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function copyCampaign(id: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(`${API_URL}Campaign/CopyCampaing/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_COMPANY, payload: response.data.data});
                    dispatch(setArchiveTableToggle(true));
                    dispatch(getCompaniesWithPaginationFilterAndSorting(sort || dataSort, jwtToken));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else {
                    dispatch(showErrorMessage(response.data.message));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getNotification(userId: any, code: number, jwtToken: any, callback?: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        axios.get(`${API_URL}Notification/LangNotification/${userId}/${code}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                setItem(`notification_code:${response.data.code}`, response.data.text, 5)
                dispatch({type: GET_NOTIFICATION, payload: response.data});
            })
            .catch(() => {
                dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
            }).finally(() => {
            if (callback) {
                callback(getItem(`notification_code:${code}`));
            }
        });
    }
}

export function getCompaniesWithPaginationFilterAndSorting(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showLoader())
        dispatch(hideError())
        axios.post(`${API_URL}Campaign/AllCampaignsWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dataSort = data;
                if (data.isArchived === false) {
                    dispatch({type: GET_COMPANIES, payload: response.data.data.items})
                } else {
                    dispatch({type: GET_COMPANIES_ARCHIVED, payload: response.data.data.items})
                }
                dispatch({type: GET_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(hideLoader())
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getCampaignContactsWithPagination(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(setContactsLoader(true));
        axios.post(`${API_URL}Statistic/GetCampaignLeadsStatisticPagination `, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.data) {
                    dispatch({type: GET_CAMPAIGN_CONTACTS, payload: response.data.data});
                    dispatch({type: GET_CAMPAIGN_CONTACTS_PAGINATION, payload: response.data.data})
                    dispatch(setContactsLoader(false));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: e.data.message}})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(setContactsLoader(false));
            })
    }
}

const pickLeadsDashboardProp = (obj: any, camel: string) => {
    if (!obj) return undefined;
    const pascal = camel.charAt(0).toUpperCase() + camel.slice(1);
    return obj[camel] ?? obj[pascal];
};

const normalizeLeadsDashboardItem = (item: any) => ({
    campaignId: pickLeadsDashboardProp(item, 'campaignId') ?? null,
    phoneTypeId: pickLeadsDashboardProp(item, 'phoneTypeId') ?? null,
    phoneTypeName: pickLeadsDashboardProp(item, 'phoneTypeName') || '',
    attemptsDone: pickLeadsDashboardProp(item, 'attemptsDone') ?? 0,
    attemptsTotal: pickLeadsDashboardProp(item, 'attemptsTotal') ?? 0,
    active: pickLeadsDashboardProp(item, 'active') ?? 0,
    activeTotal: pickLeadsDashboardProp(item, 'activeTotal') ?? 0,
    success: pickLeadsDashboardProp(item, 'success') ?? 0,
    unsuccess: pickLeadsDashboardProp(item, 'unsuccess') ?? 0,
});

const normalizeLeadsDashboard = (payload: any) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : payload && typeof payload === 'object'
                ? Object.values(payload)
                : [];
    return list.map(normalizeLeadsDashboardItem);
};

let contactsByCampaignDashboardRequestId = 0;

export function getContactsByCampaignIdDashboard(payload: {campaignId: number; filter?: {key: string; value: string}[]}, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        if (!payload?.campaignId || !jwtToken) return;
        const requestId = ++contactsByCampaignDashboardRequestId;
        dispatch({type: SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING, payload: true});
        axios.post(`${API_URL}Statistic/GetContactsByCampaignIdDashboard`, {
            campaignId: payload.campaignId,
            filter: payload.filter || []
        }, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (requestId !== contactsByCampaignDashboardRequestId) return;
                const raw = response?.data?.data ?? response?.data;
                dispatch({type: GET_CONTACTS_BY_CAMPAIGN_DASHBOARD, payload: normalizeLeadsDashboard(raw)});
            })
            .catch((e) => {
                if (requestId !== contactsByCampaignDashboardRequestId) return;
                dispatch({type: GET_CONTACTS_BY_CAMPAIGN_DASHBOARD, payload: null});
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                }
            })
            .finally(() => {
                if (requestId === contactsByCampaignDashboardRequestId) {
                    dispatch({type: SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING, payload: false});
                }
                dispatch(showAccessDeniedNotifications(false));
            });
    };
}

export function clearContactsByCampaignIdDashboard() {
    return (dispatch: (arg0: any) => void) => {
        contactsByCampaignDashboardRequestId += 1;
        dispatch({type: GET_CONTACTS_BY_CAMPAIGN_DASHBOARD, payload: null});
        dispatch({type: SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING, payload: false});
    };
}

export function getLeadsOwnerStatistic(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(setContactsLoader(true));
        axios.post(`${API_URL}Statistic/GetLeadsOwnerStatistic`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.data) {
                    const data = response.data.data;
                    const normalizedData = {
                        ...data,
                        items: (data.items || []).map((item: any) => ({
                            ...item,
                            main: {
                                contactName: item.contactName,
                                ownerUserName: item.ownerUserName
                            }
                        }))
                    };
                    dispatch({type: GET_CAMPAIGN_CONTACTS, payload: normalizedData});
                    dispatch({type: GET_CAMPAIGN_CONTACTS_PAGINATION, payload: normalizedData});
                    dispatch(setContactsLoader(false));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: e.data.message}})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(setContactsLoader(false));
            })
    }
}

export function getContactsExcel(campaignId: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(`${API_URL}CampaignContacts/GetContactsExcel/${campaignId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                window.location.href = <string>response.config.url;
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getContactsExcelForDelete(campaignId: number, userId: string | null, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(`${API_URL}CampaignContacts/GetContactsExcel/${campaignId}`, {responseType: 'blob'})
            .then((response) => {
                const formData = new FormData();
                formData.append('file', response.data);
                dispatch(deleteCampaignContacts(formData, campaignId, userId, jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function deleteCampaignContacts(formData: any, campaignId: number, userId: string | null, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.post(`${API_URL}CampaignContacts/UploadContactsExcel/${campaignId}?userId=${userId}&action=delete`, formData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then(() => {
                const dataSort = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: {
                        orderBy: "ContactName",
                        isDesc: true
                    },
                    campaignId: campaignId
                }
                dispatch(getCampaignContactsWithPagination(dataSort, jwtToken?.jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function checkUserForCall(userName: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.get(`${API_URL}UserResource/CheckUserForCall?callTo=${userName}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch({type: SET_CHECK_USER_FOR_CALL, payload: true});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                    dispatch({type: SET_CHECK_USER_FOR_CALL, payload: false});
                }
            })
            .catch((e) => {
                const isUnauthorized =
                    e?.response?.status === 401 ||
                    e?.request?.status === 401 ||
                    (e?.message === 'Network Error');

                if (isUnauthorized) {
                    dispatch(showAccessDeniedNotifications(true));
                    dispatch(showErrorTokenNotifications(true));
                    return;
                }
                else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: SET_CHECK_USER_FOR_CALL, payload: false});
            })
    }
}

export function checkSessionForSpy(sessionId: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        return axios.post(`${API_URL}SpyCall/SpyCallCreate`, sessionId,{
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch({type: SET_CHECK_SESSION_FOR_SPY, payload: true});
                    return true;
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}});
                    dispatch({type: SET_CHECK_SESSION_FOR_SPY, payload: false});
                    return false;
                }
            })
            .catch((e) => {
                const isUnauthorized =
                    e?.response?.status === 401 ||
                    e?.request?.status === 401 ||
                    (e?.message === 'Network Error');

                if (isUnauthorized) {
                    dispatch(showAccessDeniedNotifications(true));
                    dispatch(showErrorTokenNotifications(true));
                    return;
                }
                else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    dispatch(setUserError(true))
                }
                return false;
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: SET_CHECK_SESSION_FOR_SPY, payload: false});
            })
    }
}

export function getPickUpCall(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.post(`${API_URL}QueueMonitor/PickupCall`, data,{
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch({type: SET_CHECK_PICK_UP_CALL, payload: true});
                    dispatch(triggerPickupCall());
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                    dispatch({type: SET_CHECK_PICK_UP_CALL, payload: false});
                }
            })
            .catch((e) => {
                const isUnauthorized =
                    e?.response?.status === 401 ||
                    e?.request?.status === 401 ||
                    (e?.message === 'Network Error');

                if (isUnauthorized) {
                    dispatch(showAccessDeniedNotifications(true));
                    dispatch(showErrorTokenNotifications(true));
                    return;
                }
                else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: SET_CHECK_USER_FOR_CALL, payload: false});
            })
    }
}

export function getCampaignACDDictionaryType(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.get(`${API_URL}DialerDictionary/GetDictionary/true?parentId=500`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_CAMPAIGN_ACD_DICTIONARY, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getCampaignsForLeadsList(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.get(`${API_URL}Campaign/GetCampaigns?isAchived=false`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_CAMPAIGNS_FOR_LEADS_LIST, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

function getDictionariesByParentId(data: any[], parentId: any, options = { onlyActive: true }) {
    return data?.filter(item =>
        item.parentId === parentId &&
        (options.onlyActive ? item.isActive : true)
    );
}

export function getDialerDictionary(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());

        dispatch(showGetCampaignDirectoriesPhoneTypeError(false));
        dispatch(getCampaignDirectoriesCampaignTypeError(false));
        dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR, payload: false});
        dispatch(showLoaderStrategyDict());

        axios.post(`${API_URL}CampaignsDictionary/GetDictionariesValues`, [
            {
                "parentId": 100
            },{
                "parentId": 200,
                "isActive": true
            },{
                "parentId": 300,
                "isActive": true
            },{
                "parentId": 400,
                "isActive": true
            },{
                "parentId": 500,
                "isActive": true
            }
        ], {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const allItems100 = getDictionariesByParentId(response.data?.data, 100, { onlyActive: false });
                const allItems200 = getDictionariesByParentId(response.data?.data, 200, { onlyActive: false });
                const allItems300 = getDictionariesByParentId(response.data?.data, 300, { onlyActive: false });
                const allItems400 = getDictionariesByParentId(response.data?.data, 400, { onlyActive: false });
                const allItems500 = getDictionariesByParentId(response.data?.data, 500, { onlyActive: false });

                dispatch({type: GET_COMPANIES_DIRECTORIES_PHONE_TYPE, payload: allItems100});
                dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_TYPE, payload: allItems200});
                dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY, payload: allItems300});
                dispatch({type: GET_COMPANIES_DIRECTORIES_SCHEDULER_TYPE, payload: allItems400});
                dispatch({type: GET_CAMPAIGN_ACD_DICTIONARY, payload: allItems500});

                dispatch(hideLoaderStrategyDict());
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(showGetCampaignDirectoriesPhoneTypeError(true));
                    dispatch(getCampaignDirectoriesCampaignTypeError(true));
                    dispatch({type: GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR, payload: true});
                    dispatch(showError());
                }
                dispatch(hideLoaderStrategyDict());
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function generateCampaignLeadsExcel(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.post(`${API_URL}Statistic/GenerateStatistic?type=4`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null})
                return dispatch(setUserError(false));
            })
    }
}

export function getCampaignLeadsFilesHistory(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SET_CAMPAIGN_LEADS_FILES_HISTORY_LOADER, payload: true});
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        axios.post(`${API_URL}Statistic/GetFilesHistory?type=4`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: GET_CAMPAIGN_LEADS_FILES_HISTORY, payload: response.data.data.items});
                dispatch({type: GET_CAMPAIGN_LEADS_FILES_PAGINATION, payload: response.data.data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_CAMPAIGN_LEADS_FILES_HISTORY_LOADER, payload: false});
                dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
            })
    }
}

export function deleteCampaignLeadsFileById(id: number | any, dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteFileById?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch(getCampaignLeadsFilesHistory(dataSort, jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function deleteAllCampaignLeadsFiles(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteAllFiles`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch({type: GET_CAMPAIGN_LEADS_FILES_HISTORY, payload: null});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function getCampaignLeadsExcelByLink(id: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.get(`${API_URL}Statistic/GetTempUrlFile?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                const fileUrl = response.data.data;
                const fileName = response.data.title || 'export.xlsx';

                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    dispatch(setUserError(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(setUserError(false));
            });
    }
}

export function getDefaultAmdSettings(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.get(`${API_URL}Campaign/GetDefaultAmdSettings`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    const settings = response.data;
                    dispatch({type: SET_CAMPAIGN_AMD_SETTINGS, payload: settings});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
                return dispatch(setUserError(false))
            })
    }
}
